import { DateFormats, DateObject } from '@uplift/services';
import { WeekDay, WeekDayKeys } from '@uplift/types';
import { getAvailabilityTemplate } from '@uplift/api';
import { useQuery } from '@tanstack/react-query';


export const useAvailabilityOverrideData = (userId: string, date: DateObject, enabled = true) => {
  return useQuery(
    [ 'availabilityTemplate', userId, date ] as const,
    async () => {
      const formattedDate = date.format(DateFormats.date);
      const weekKey = WeekDay[date.day()] as WeekDayKeys;
      const data = await getAvailabilityTemplate({ date_from: formattedDate, date_to: formattedDate });

      return {
        currentRanges: data.overrides[formattedDate] || data.days[weekKey],
        defaultRanges: data.days[weekKey],
      };
    },
    {
      enabled: enabled,
    }
  );
};
